import { Component, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-location',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './location.html',
  styleUrls: ['./location.scss']
})
export class LocationComponent implements AfterViewInit {
  @ViewChild('video', { static: true }) video!: ElementRef<HTMLVideoElement>;

ngAfterViewInit() {
  const video: HTMLVideoElement | null = document.querySelector('#locationVideo');

  if (!video) return;

  const playVideo = () => {
    const p = video.play();
    if (p !== undefined) {
      p.catch(() => {});
    }
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) playVideo();
    });
  }, { threshold: 0.3 });

  observer.observe(video);
}

}


